export default __webpack_public_path__ + "static/media/152.f8ecfb72.jpg";